import React from 'react';
import ListHorizontal from './ListHorizontal';
import { useRelatedPosts } from '../../hooks/useRelatedPosts';

interface RelatedPostsProps {
  postId: string;
  postType: string;
  title?: string;
}

const RelatedPosts: React.FC<RelatedPostsProps> = ({ postId, postType, title = 'Related Posts' }) => {
  const { data: relatedPosts, isLoading, error } = useRelatedPosts(postId, postType, 1);

  if (error) {
    return null;
  }

  if (isLoading) {
    return <div className="px-4">
      <div className="h-8 w-32 bg-gray-700 animate-pulse rounded mb-4"></div>
      <div className="flex space-x-4 overflow-hidden">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="flex-shrink-0 w-[180px]">
            <div className="w-full h-[270px] bg-gray-700 animate-pulse rounded"></div>
          </div>
        ))}
      </div>
    </div>;
  }

  if (!relatedPosts || relatedPosts.length === 0) {
    return null;
  }

  return (
    <ListHorizontal
      title={title}
      movies={relatedPosts}
      type="lists"
      posttype={postType}
      api={`/posts/lists/${postType}/related`}
    />
  );
};

export default RelatedPosts;
